var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kt_header",staticClass:"kt-header kt-grid__item",attrs:{"id":"kt_header"}},[_c('b-row',{staticClass:"w-100"},[_c('b-col'),_c('b-col',[_vm._t("default")],2),_c('b-col')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }